// extracted by mini-css-extract-plugin
export default {"root":"VigboLicenceNote__root--39o5b","link":"VigboLicenceNote__link--30tie"};